import styled from '@emotion/styled';

export const Container = styled.div``;

export const Label = styled.div`
  margin-bottom: 4px;
  font-size: 14px;
`;

export const StyledSelect = styled.div`
  width: 100%;
  max-width: 500px;

  && .ui-select-selector {
    min-width: 200px;
  }
`;

export const LoadMoreContainer = styled.div`
  padding: 8px;
  text-align: center;
  border-top: 1px solid #f0f0f0;
`;

export const LoadMoreButton = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  color: #1890ff;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  padding: 4px 8px;
`;